import BlazeInsightsIcon from './blaze-insights.png'
import blazeRetailLogo from './blaze_retail_logo.svg'
import C2QB from './C2QB_green.png'
import CloverGrey from './clover-grey.png'
import CloverWhite from './clover-white.png'
import DifferentValue from './different-value.svg'
import dispatchLogo from './dispatchLogo.svg'
import distributionLogo from './distributionLogo.png'
import ErrorIconFees from './erroricon.svg'
import ExportInvBatch from './export.svg'
import GppGood from './gpp_good_24dp_E3E3E3.svg'
import growLogo from './growLogo.png'
import ImportInvBatch from './import.svg'
import InfoIcon from './info-icon.svg'
import insightsLogo from './insightsLogo.svg'
import LeaflyGrey from './leafly-grey.svg'
import LeaflyWhite from './leafly-white.svg'
import LinkValue from './link-value.svg'
import loginCover from './login_cover.jpg'
import MTracGrey from './mtrac_grey.png'
import MTracWhite from './mtrac_white.png'
import NextPage from './nextPage.svg'
import NoImagePlaceholder from './no-image.jpg'
import UnLinkValue from './no-link-value.svg'
import OnfleetGrey from './onfleet-logo-grey.svg'
import OnfleetWhite from './onfleet-logo-white.svg'
import PreviousPage from './previousPage.svg'
import QrCodeSvg from './qr_code.svg'
import QuickBookGrey from './quickbook_grey.png'
import QuickBookWhite from './quickbook_white.png'
import retailLogo from './retailLogo.png'
import SameValue from './same-value.svg'
import SpenceGray from './spence-gray.svg'
import SpencePurple from './spence-purple.svg'
import SpringBigGrey from './springbig-logo-grey.svg'
import SpringBigWhite from './springbig-logo-white.svg'
import stronghold from './stronghold.png'
import strongholdGray from './strongholdGray.png'
import TemplateProducts from './template-master-products.csv'
import UniqueAttributesGrey from './unique-attributes-grey.png'
import UniqueAttributesWhite from './unique-attributes-white.png'
import VerticalDots from './vertical-dots.svg'
import WeedmapsGrey from './weedmaps-logo-grey.svg'
import WeedmapsWhite from './weedmaps-logo-white.svg'
import WmDispatchLogo from './wmDispatch_logo.svg'

export {
  BlazeInsightsIcon,
  blazeRetailLogo,
  C2QB,
  CloverGrey,
  CloverWhite,
  DifferentValue,
  dispatchLogo,
  distributionLogo,
  ErrorIconFees,
  ExportInvBatch,
  GppGood,
  growLogo,
  ImportInvBatch,
  InfoIcon,
  insightsLogo,
  LeaflyGrey,
  LeaflyWhite,
  LinkValue,
  loginCover,
  MTracGrey,
  MTracWhite,
  NextPage,
  NoImagePlaceholder,
  OnfleetGrey,
  OnfleetWhite,
  PreviousPage,
  QrCodeSvg,
  QuickBookGrey,
  QuickBookWhite,
  retailLogo,
  SameValue,
  SpenceGray,
  SpencePurple,
  SpringBigGrey,
  SpringBigWhite,
  stronghold,
  strongholdGray,
  TemplateProducts,
  UniqueAttributesGrey,
  UniqueAttributesWhite,
  UnLinkValue,
  VerticalDots,
  WeedmapsGrey,
  WeedmapsWhite,
  WmDispatchLogo,
}



// WEBPACK FOOTER //
// ./src/assets/index.js